import { useState, useRef, useCallback } from "react";

export const useListLoading = (debounceMs = 300) => {
  const [isSearching, setIsSearching] = useState(false);
  const timeoutRef = useRef(null);

  const startSearch = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsSearching(true);
  }, []);

  const endSearch = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setIsSearching(false);
    }, debounceMs);
  }, [debounceMs]);

  return { isSearching, startSearch, endSearch };
};